// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"c0bf76bd","97":"5cad2289","131":"89675c09","157":"dc80615a","371":"095e9ae2","374":"dc7efccf","624":"8a1f3661","739":"7a961122","825":"2fd3ec5c","879":"852c9f65","909":"b7bde20d"}[chunkId] + ".chunk.css";
};